import React from 'react';
/**
 * @name BlockErrorComponent
 * @description Retorna classe css com mensagem de erro
 * @param  {string} message - Mensagem de error
 */
export default ({message, visible}) => visible ? <span className="block-error">{message}</span> : <></>
